class TableEl extends HTMLElement {
  connectedCallback() {
    this.tabButtons = this.querySelectorAll('.table__tab-btn');
    this.panels = this.querySelectorAll('.table__panel');
    this.rows = this.querySelectorAll('.table__row');
    this.preview = this.querySelector('.table__preview');
    this.previewImage = this.querySelector('.table__preview-image');
    this.headers = this.querySelectorAll('.table__header button');
    this.isSearch = this.dataset.search === '1';

    this.initTabs();
    this.initHoverPreview();
    this.initSorting();
    this.showFirstImage();

    if (this.isSearch) {
      const activePanel = this.querySelector('.table__panel.is-active');
      const grid = activePanel.querySelector('.table__grid');
      if (grid) {
        this.preview.style.height = `${grid.offsetHeight}px`;
      }
    }
  }

  showFirstImage() {
    // Get the first row's image
    const firstRow = this.rows[0];
    if (firstRow && firstRow.dataset.image) {
      this.previewImage.src = firstRow.dataset.image;
      this.preview.classList.add('is-visible');
      // Add active state to first row
      firstRow.classList.add('is-active');
    }
  }

  initTabs() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons and panels
        this.tabButtons.forEach(btn => btn.classList.remove('is-active'));
        this.panels.forEach(panel => panel.classList.remove('is-active'));

        // Add active class to clicked button and corresponding panel
        button.classList.add('is-active');
        const panelId = button.dataset.tab;
        const activePanel = this.querySelector(`[data-panel="${panelId}"]`);
        activePanel.classList.add('is-active');

        // Reset animations for the newly activated panel
        const animTriggers = activePanel.querySelectorAll('.anim-trigger');
        animTriggers.forEach(trigger => {
          window.removeAndReobserve(trigger);
        });

        // Update preview height if isSearch is true
        if (this.isSearch) {
          const grid = activePanel.querySelector('.table__grid');
          if (grid) {
            this.preview.style.height = `${grid.offsetHeight}px`;
          }
        }

        // Show first image of newly activated panel
        const firstRowInPanel = activePanel.querySelector('.table__row');
        if (firstRowInPanel && firstRowInPanel.dataset.image) {
          this.previewImage.src = firstRowInPanel.dataset.image;
          this.preview.classList.add('is-visible');
          
          // Remove active state from all rows
          this.rows.forEach(row => row.classList.remove('is-active'));
          // Add active state to first row
          firstRowInPanel.classList.add('is-active');
        }
      });
    });
  }

  initHoverPreview() {
    this.rows.forEach(row => {
      row.addEventListener('mouseenter', () => {
        const imageUrl = row.dataset.image;
        if (imageUrl) {
          this.previewImage.src = imageUrl;
          this.preview.classList.add('is-visible');
          
          // Remove active state from all rows
          this.rows.forEach(r => r.classList.remove('is-active'));
          // Add active state to hovered row
          row.classList.add('is-active');
        }
      });
    });
  }

  initSorting() {
    this.headers.forEach(header => {
      header.addEventListener('click', () => {
        const activePanel = this.querySelector('.table__panel.is-active');
        const rows = Array.from(activePanel.querySelectorAll('.table__row'));
        const columnIndex = Array.from(header.parentElement.children).indexOf(header);
        
        // Toggle sort direction
        const isAscending = !header.classList.contains('sort-asc');
        
        // Remove sort classes from all headers
        this.headers.forEach(h => {
          h.classList.remove('sort-asc', 'sort-desc');
        });
        
        // Add appropriate sort class to clicked header
        header.classList.add(isAscending ? 'sort-asc' : 'sort-desc');
        
        // Sort the rows
        rows.sort((a, b) => {
          const aValue = a.children[columnIndex].textContent.trim();
          const bValue = b.children[columnIndex].textContent.trim();
          return isAscending 
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        });
        
        // Reorder the rows in the DOM
        const grid = activePanel.querySelector('.table__grid');
        rows.forEach(row => grid.appendChild(row));
      });
    });
  }
}

customElements.define('table-el', TableEl);